module.exports = __webpack_public_path__ + "static/media/1.0c2df5c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/1.jpg
// module id = 235
// module chunks = 0